import { useMemo } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
const useStoreLocatorDb = () => {
  const data = useStaticQuery(graphql`
    query getStoreDb {
      storeDb {
        internal {
          content
        }
      }
    }
  `);

  return useMemo(() => {
    const db = JSON.parse(data.storeDb.internal.content || '{}');
    return db;
  }, []);
};

export default useStoreLocatorDb;
